import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import { updateV2SocketData } from './internal/v2-helper';
import { r230522SocketBunja } from './socket';
import { tickersBunja } from './tickers';
import { WsV2TableEvent } from './types';

type SnapshotSpotTicker = Record<string, SpotTicker>;
export type SpotTickers = SnapshotSpotTicker | null;

export interface SpotTicker {
  priceChange24h: string;
  high24h: string;
  low24h: string;
  volume24h: string;
  // 중복
  midPrice: string;
  lastPrice?: string;
  priceChangePct24h: string;
  turnover24h: string;
}

const checkDiffSpotTicker = (prev: SnapshotSpotTicker, next: SnapshotSpotTicker) => {
  return Object.entries(next).some(([symbol, ticker]) => {
    return Object.entries(ticker).some(([key, value]) => value !== prev[symbol]?.[key as keyof SpotTicker]);
  });
};

function updateSpotTickers(prev: SpotTickers, wsData: WsV2TableEvent<SpotTicker>['data']) {
  const prevTickers = prev || {};
  if (wsData.s && checkDiffSpotTicker(prevTickers, wsData.s)) {
    return updateV2SocketData(prevTickers, wsData);
  }
  return prevTickers;
}

const spotTickersAtom = atom<SpotTickers>(null);
export const spotTickerBunja = bunja(() => {
  const { r230522Socket } = bunja.use(r230522SocketBunja);
  const store = bunja.use(JotaiStoreScope);
  const { setCurrentSpotTicker } = bunja.use(tickersBunja);
  function setCurrentTicker(ticker: string | null = null) {
    setCurrentSpotTicker(ticker);
  }

  bunja.effect(() => {
    function handler(event: WsV2TableEvent<SpotTicker>) {
      if (!event.data) return;
      store.set(spotTickersAtom, (prev) => updateSpotTickers(prev, event.data));
    }

    r230522Socket.on('market/spot-tickers', handler);

    return () => {
      setCurrentSpotTicker(null);
      r230522Socket.off('market/spot-tickers', handler);
    };
  });

  return {
    spotTickersAtom,
    setCurrentTicker,
  };
});
spotTickerBunja.debugLabel = 'spotTickersBunja';
